import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  CustomizePrint,
  Navigation,
  Products,
  Theme,
  EditUnauthorized,
} from 'components'
import { themesAtom, productsAtom, caseAtom } from 'atoms'
import { useRecoilValue } from 'recoil'
import { productsCategories, themeCategories } from 'mocks'
import { useDynamicStyles, useStonlyWidget, useTokenValidation } from 'hooks'
import { useCaseInfo } from 'hooks/utility/useCaseInfo'
import { isTokenizedEditSession } from '@messenger/consts'
import previewGlobal from 'styles/previewGlobal'
import { Flex } from 'components/priority/Flex/Flex'
import { usePostHog } from 'posthog-js/react'
import { initializeSessionRecording } from 'utils/global/posthog'

export const Package = () => {
  const location = useLocation()
  const { pathname: locationPath } = location

  const [, , , slug] = locationPath.split('/')
  const themes = useRecoilValue(themesAtom)
  const products = useRecoilValue(productsAtom)
  const caseInfo = useRecoilValue(caseAtom)
  const posthog = usePostHog()
  const { caseHeader } = useCaseInfo(caseInfo)

  const isMessengerAccess = isTokenizedEditSession(location.search)
  const { isValidSession, returnUrl, shouldCloseTab } =
    useTokenValidation(isMessengerAccess)

  useDynamicStyles(previewGlobal)
  useStonlyWidget()

  useEffect(() => {
    if (posthog) {
      initializeSessionRecording(posthog)
    }
  }, [posthog])

  // Show loading state while checking validation
  if (isValidSession === null) {
    return null
  }

  // Show unauthorized if validation failed
  if (isValidSession === false) {
    return (
      <EditUnauthorized
        returnUrlProp={returnUrl}
        shouldCloseTab={shouldCloseTab}
      />
    )
  }

  return (
    <>
      <Navigation type="package" />
      {slug === 'products' && (
        <Products
          caseInfo={caseHeader}
          categories={productsCategories}
          products={products}
        />
      )}
      {slug === 'theme' && (
        <Theme caseInfo={caseHeader} themes={themes || themeCategories} />
      )}
      {slug === 'customize' && (
        <CustomizePrint caseInfo={caseHeader} categories={themeCategories} />
      )}
      <Flex margin="0 0 100px 0" />
    </>
  )
}

export default Package
